import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { updatePersona } from '../../services/apiService';
import ImageUpload from '../initializer/ImageUpload';
import styles from './EditPassportModal.module.css';

const EditPassportModal = ({ digitalLegacy, onClose, onSave }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState({
    personaName: digitalLegacy.personaName || '',
    summary: digitalLegacy.summary || '',
    imageUrl: digitalLegacy.imageUrl || null,
  });
  const [isSaving, setIsSaving] = useState(false);
  const [newImagePreview, setNewImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadSuccess = ({ finalImageUrl, previewUrl }) => {
    setFormData((prev) => ({ ...prev, imageUrl: finalImageUrl }));
    setNewImagePreview(previewUrl);
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const accessToken = await getAccessTokenSilently();
      await updatePersona(digitalLegacy.personaId, formData, accessToken);
      onSave();
      onClose();
    } catch (error) {
      console.error('Failed to update Digital Passport:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={() => onClose()}>
          &times;
        </button>
        <h3>Edit Digital Passport</h3>
        <p>Update the core identity of your private Digital Passport.</p>

        <div className={styles.formGroup}>
          <label>Passport Avatar</label>
          <ImageUpload onUploadSuccess={handleUploadSuccess} />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="personaName">Your Full Name</label>
          <input
            type="text"
            id="personaName"
            name="personaName"
            value={formData.personaName}
            onChange={handleChange}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="summary">Summary</label>
          <textarea
            id="summary"
            name="summary"
            rows="4"
            value={formData.summary}
            onChange={handleChange}
          />
        </div>

        <div className={styles.modalActions}>
          <button onClick={onClose} className="action-button secondary">
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="action-button primary"
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPassportModal;
